import React from 'react';
import { getPlayerAvatar } from '../../utils/player';
import PlayerStatTiles from './PlayerStatTiles';
import { BadgesTile } from './ProfileBadges';

// Profile tab card (Figma 791:19165). Account settings and the More menu live in the app header.
export default function ProfileView({
  user,
  userProfile,
  allPlayers,
  overallStats = {},
  playerStreaks = {},
  eventMvpCounts = {},
  badges,
  onOpenAchievements,
}) {
  const userName = userProfile?.name || user?.displayName || 'Player Name';
  const avatarUrl = getPlayerAvatar(allPlayers, userName);

  // Match stats for the current user from the shared matchStats module (#34),
  // same numbers as the standings tables and player card
  const playerStats = overallStats[userName] || {};
  // Same source as the player card: overallInsights has no per-player streak, so reading it here always gave 0
  const longestStreak = playerStreaks[userName] ?? playerStats.longestWinStreak ?? 0;
  const eventWins = eventMvpCounts[userName] ?? playerStats.eventWins ?? 0;

  return (
    <div className="profile-view">
      <div className="profile-card pc-anim-card">
        {/* Avatar sits half over the card's top edge */}
        <div className="profile-card__avatar pc-anim-avatar">
          <div className="pc-anim-avatar-ring">
            <img src={avatarUrl} alt={userName} className="avatar avatar-border" />
          </div>
        </div>

        <h2 className="profile-card__name pc-anim-name">{userName}</h2>

        <PlayerStatTiles layout="grid" playerStats={playerStats} eventWins={eventWins} longestStreak={longestStreak} />
        <BadgesTile badges={badges} uid={user?.uid} onOpen={onOpenAchievements} />
      </div>
    </div>
  );
}
